var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.wishlistCount > 0),expression:"wishlistCount > 0"}],staticClass:"wishlist-badge",domProps:{"innerHTML":_vm._s(_vm.wishlistCount)}})}
var staticRenderFns = []

export { render, staticRenderFns }